<template lang="html">
  <div class="photo-blocks">
    <h2 class="list-title" v-if="title" v-html="title"></h2>

    <div class="container grid">
      <div
        class="grid-section"
        v-for="(section, index) in splitContent"
        :key="`section-${index}`"
      >
        <div
          :class="
            isDivisible(section) ? 'is-divisible' : 'is-remainder'
          "
        >
          <a
            v-for="(item, index) in section"
            :title="`This links to: ${parse(item).link}`"
            @click="highlightField('text')"
            :class="index > 0 ? 'short' : 'tall'"
            :key="`item-${index}`"
            class="grid-content"
          >
            <div
              class="item-image"
              :style="{backgroundImage: `url('${image(item)}')`}"
            ></div>

            <div class="item-inner">
              <h2>{{parse(item).heading}}</h2>
            </div>

            <div class="item-text">
              <div v-html="parse(item).text"></div>
              <a
                class="item-link btn is-dark"
                v-if="parse(item).link"
                :title="`This links to: ${parse(item).link}`"
              >
                <span style="color: white">{{ parse(item).link_text }}</span>
              </a>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import parseComponent from '@/mixins/parseComponent'

export default {
  name: 'ImageGrid',

  mixins: [parseComponent],

  props: {
    title: String,
    demoMode: Boolean,

    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  },

  computed: {
    splitContent() {
      let groups = []
      let split = 3

      for (let i = 0; i < this.items.length; i += split) {
        groups.push(this.items.slice(i, i + split))
      }

      return groups
    },

    image() {
      return (item) => {
        return this.demoMode ? this.parse(item).image_url : item.image_versions[0].url
      }
    }
  },

  methods: {
    isDivisible(content) {
      return content.length % 3 === 0
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/base/theme'

$borderWidth: 4px
$sectionHeight: 450px
$sectionHeightRemainder: $sectionHeight / 2

.grid
  padding: $gap-small
  box-shadow: $content-shadow

  .grid-section
    clear: both
    margin: auto

    @include media($media-gt-medium)
      &:nth-child(even)
        .tall
          float: right

        .short
          float: left

    &:last-child
      .grid-content
        margin-bottom: 0

  .grid-content
    overflow: hidden
    position: relative
    margin-bottom: $gap-small
    text-decoration: none
    display: flex
    flex-direction: column
    cursor: pointer

    @include media($media-gt-medium)
      width: 100%
      height: 100%
      margin: 2px

      &:hover
        .item-image
          transform: scale(1.05)

        .item-inner
          opacity: 0

        .item-text
          opacity: 1

.photo-blocks
  .list-title
    text-align: center
    margin: $gap-small

  .item-inner,
  .item-text
    padding: $gap-medium
    text-align: center
    pointer-events: none
    position: absolute
    margin: auto
    transition: opacity .3s ease-in-out
    background: rgba(255, 255, 255, 0.7)

  .item-inner
    top: 50%
    left: 50%
    width: 320px
    transform: translate(-50%, -50%)
    border-radius: 5px

  .item-text,
  .item-image
    width: 100%
    height: 100%
    display: flex
    align-items: center

    *
      color: #333

  .item-text
    opacity: 0
    flex-direction: column
    justify-content: center

  .item-image
    align-items: center
    background-size: cover
    background-position: 50% 50%
    height: 100%

  .item-link
    margin-top: $gap-small

  @include media($media-gt-medium)
    .item-image
      transform: scale(1)
      transition: transform .5s ease-in-out

    .is-divisible
      height: $sectionHeight
      clear: both

      .tall, .short
        width: calc(50% - #{$borderWidth})

      .tall
        height: calc(100% + #{$borderWidth})
        float: left

      .short
        height: 50%
        float: right

  .is-remainder
    @include media($media-gt-medium)
      height: $sectionHeightRemainder
      display: flex
      height: $sectionHeight

      .grid-content
        height: calc(100% - #{$borderWidth})
        flex-basis: 100%
</style>
